 /*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import './Spinner.css'

// Spinners are CSS loading indicators that should be shown when retrieving data or performing slow computations.

// SLDS types:
// With Container
// The regular spinner container is used making the dark background look lighter.
// The spinner container will position itself to the closest positioned parent.
// So if you want it to spin over a single component, the class 'slds-is-relative' can be added to the parent.

// Fixed Container
// The spinner container may be used with a container with fixed positioning by adding
// the 'slds-is-fixed' class to the container. This may be needed if you are dynamically
// loading portions of a component after the spinner is showing.

export const Spinner = ({ type, size, children, top, className }) => {
  // slds spinner types
  if (["default", "brand", "inverse"].indexOf(type) > -1) {
    return (
      <div className={`slds-spinner_container ${className ? className : ''}`}>
        <div
          role="status"
          className={`slds-spinner slds-spinner_${size}${type !== "default" ? ` slds-spinner_${type}` : ''}`} style={top ? { top: '25%' } : null}>
          <div className="slds-spinner__dot-a"></div>
          <div className="slds-spinner__dot-b"></div>
        </div>
      </div>
    )
  } else {  // custom spinner types
    return (
      <div className={`slds-align_absolute-center ${className ? className : ''}`}>
        <div className={`spinner_${type}`} />
        <div className="spinner_dots-text slds-text-body_regular">
          {children}
        </div>
      </div>
    )
  }
}

Spinner.defaultProps = {
  size: "medium",
  type: "default"
}

Spinner.propTypes = {
  size: PropTypes.oneOf([ "xx-small", "x-small", "small", "medium", "large" ]),
  type: PropTypes.oneOf([ "default", "brand", "inverse", "dots", "tail", "track" ]),
  top: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/spinner/index.js